// Generic higher-order component function
import React, { ComponentProps, ElementType, FC, HTMLProps } from "react";

export function withClassName<T extends ElementType>(
    Component: T,
    defaultClassName: string
) {
    const WithClassName = (props: ComponentProps<T>) => {
        const { className, ...rest } = props;
        return (
            <Component
                className={`${defaultClassName} ${className || ""}`}
                {...(rest as any)}
            />
        );
    };
    return WithClassName;
}
